// extracted by mini-css-extract-plugin
export default {"slider":"gallerySlider_slider__655w9"};